import { createClient } from "@supabase/supabase-js";

// Ganti URL dan KEY ini dengan data dari Dashboard Supabase Anda
// Caranya: Di Supabase, Klik Settings (Roda Gigi) -> API
const supabaseUrl = "https://ngxjivfixlfvedtjutmr.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5neGppdmZpeGxmdmVkdGp1dG1yIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjcxMjU5ODEsImV4cCI6MjA4MjcwMTk4MX0.XRKRqXzddcFl8-DDWBedHINisT5arsgEAaGx3ZXeb9c";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
